import { z } from "zod";

import { type Resolve } from "@/utils/types";

import { attachmentSchema } from "./attachment";
import { mentionSchema } from "./mention";
import { dateSchema, filteredArray } from "./utils";

const placeholderSchema = z
  .object({
    id: z.string(),
    status_id: z.string().optional().catch(undefined),
    uri: z.string().optional().catch(undefined),
    media_attachments: filteredArray(attachmentSchema).catch([]),
    published: z.boolean().catch(false),
    draft: z.object({
      group_timeline_visible: z.boolean().catch(false),
      group_id: z.number().optional().catch(undefined),
      mentions: filteredArray(mentionSchema).optional(),
      poll: z
        .object({
          expires_in: z.string().optional(),
          multiple: z.boolean().catch(false),
          options: z.array(z.string()),
        })
        .optional()
        .catch(undefined),
      quote_id: z.string().optional().catch(undefined),
      news_article_id: z.string().optional().catch(undefined),
      sport_type: z.string().optional().catch(undefined),
      sport_game_id: z.string().optional().catch(undefined),
      status: z.string().optional().catch(undefined),
      text: z.string().optional().catch(undefined),
      to: z.array(z.string()).optional(),
    }),
    updated_at: dateSchema,
    scheduled_at: dateSchema.optional().catch(undefined),
  })
  .transform((placeholder) => {
    return {
      ...placeholder,
      draft: {
        ...placeholder.draft,
        text: placeholder.draft.text || placeholder.draft.status, // for scheduled statuses, the API returns status but not text\
        group_id: placeholder.draft.group_id?.toString(),
      },
    };
  });

type Placeholder = Resolve<z.infer<typeof placeholderSchema>>;

export { placeholderSchema, type Placeholder };
